module.exports = __webpack_public_path__ + "img/img_slide_1.20c678bc.webp";